<template>
  <v-container fluid>
    <notifications group="actions"></notifications>
    <h2>
      <router-link :to="'/job-offers/list'">Job Offers</router-link> &raquo; {{jobOffer.title}}
    </h2>
    <v-flex>
      <v-row>
        <v-col cols="12" lg="2" md="2">Title</v-col>
        <v-col cols="12" lg="9" md="9">{{jobOffer.title}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">Company</v-col>
        <v-col cols="12" lg="9" md="9">{{jobOffer.company.name}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">SalaryRange</v-col>
        <v-col cols="12" lg="9" md="9">{{jobOffer.salaryRange}}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="2" md="2">Description</v-col>
        <v-col cols="12" lg="9" md="9">{{jobOffer.description}}</v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>

<script>
  import api from '@/api/index';

  export default {
    name: "Detail",
    data() {
      return {
        jobOffer: {},
      }
    },
    methods: {
      getJobOffer() {
        api.jobOffers.getOne({_id: this.$route.params.id}).then(response => {
          this.jobOffer = response.data.data.jobOffer;
          if (this.jobOffer.salary === undefined) {
            this.jobOffer.salary = {};
          }
        })
      },

    },
    mounted() {
      this.getJobOffer();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/job-offers/Detail.vue